<template>
  <custom-dialog :visible="visible" width="450px" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form" size="mini">
        <el-form-item :label="$t('dms_changeDeviceBizTypeDialog.sbyglx')" prop="deviceBizType" class="form-must">
          <custom-select  :dataFilter="dataFilter" :clearable="false" code="dms_device_biz_type" v-model="form.deviceBizType" :placeholder="$t('dms_changeDeviceBizTypeDialog.xuan_ze')" style="width: 400px"></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        deviceBizType: '',
      },
    };
  },
  mounted() {
    this.form.deviceBizType = this.model.row.deviceBizType;
  },
  methods: {
    dataFilter(list) {
      return list.filter(t => t.name !== 'D' && t.name !== 'F');
    },
    onSave() {
      this.$postJSON(`${apis.NextDeviceBizType}/${this.model.row.deviceId}/${this.form.deviceBizType}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss">
.device-project-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    height: 413px;
    width: 100%;
    padding: 0 !important;
    display: flex;
    border-bottom: 1px solid #e9ebec;
    .msg-content {
      width: 260px;
      padding: 0 24px;
      height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
